export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  filter:{searchText: string;status:number},
  sortField: string;
  sortOrder: string;
};

export type MasterTableDataType = {
   id: number;
  description: string;
  code: string;
};

export type MasterDataType = {
  id: number | null;
  code: string;
  description: string;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  code: string;
  description: string;
};

export const initialFormData: MasterFormDataType = {
  code: "",
  description: "",
};
